<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import ServiceWorkerManager from 'firepuma-vue-axios-vuex-extensions/vue-serviceworker/components/ServiceWorkerManager.vue'
import ErrorAlerts from 'firepuma-vue-axios-vuex-extensions/vuex-errors/components/ErrorAlerts.vue'
import AppFooter from '@/AppFooter.vue';

export default {
  name: 'App',
  data: () => ({
    transitionName: '',
  }),
  computed: {
    ...mapGetters(['appName', 'isAnythingBusy']),
    ...mapState('auth', ['isAuthenticated', 'busyAuthenticating', 'hasError', 'authToken', 'authRefreshToken', 'loginUrl']),
    layout() { return (this.$route.meta.layout || 'default') + '-layout'; },
  },

  created() {
    this.INIT_AUTHENTICATION({ initialAuthToken: this.authToken, initialRefreshToken: this.authRefreshToken })
  },

  methods: {
    ...mapActions('auth', ['INIT_AUTHENTICATION']),
  },

  watch: {
    $route(to, from) {
      this.transitionName = to.meta.noTransition || from.meta.noTransition ? '' : 'fade'
    },
  },

  components: {
    ServiceWorkerManager,
    ErrorAlerts,
    AppFooter,
  },
}
</script>

<template>
  <div class="app-container" :class="{'debug-mode': $debugMode}">
    <b-progress v-if="isAnythingBusy" :value="100" animated class="fixed-top" style="height:3px;" variant="info"></b-progress>

    <div v-if="$debugMode"
      class="debug-mode-notice"
      @click="$disableDebugMode()">You are running in debug mode (click to disable)</div>

    <div v-if="!isAuthenticated&&!busyAuthenticating&&hasError" class="container">
      <div class="row mt-5">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <b-card bg-variant="danger" text-variant="white">
            <p>An error has occurred trying to determine whether you are logged in.</p>
            <p>Please ensure you have an active internet connection and click below to Sign in.</p>
          </b-card>
        </div>
      </div>
    </div>

    <div v-if="isAuthenticated">
      <!-- <img src="./assets/logo.png"> -->
      <component :is="layout">
        <transition :name="transitionName"
          mode="out-in">
          <!-- :key required to ensure component of Object mounted() is fired -->
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </component>
    </div>
    <div v-else-if="busyAuthenticating" class="container mt-5">
      <b-card>
        Application is starting up, please wait...
        <b-progress :value="100" animated variant="info"></b-progress>
      </b-card>
    </div>
    <div v-else>
      <div class="container">
        <div class="row mt-5">
          <div class="col-sm-12 col-md-6 offset-md-3">
            <b-card>
              <div class="text-center">Welcome to {{appName}}.<br>Please sign in to continue.</div>

              <a v-if="loginUrl"
                :href="loginUrl"
                class="btn btn-dark submit-button btn-block mt-3">Sign in</a>
              <i v-else
                class="fa fa-spinner fa-spin"></i>
            </b-card>
          </div>
        </div>
      </div>
    </div>

    <error-alerts class="error-alerts"></error-alerts>

    <service-worker-manager />

    <app-footer v-if="isAuthenticated" class="footer" />

  </div>
</template>

<style scoped>
#app.debug-mode {
  padding-bottom: 36px;
}
.debug-mode-notice {
  position: fixed;
  font-size: 24px;
  color: orangered;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.error-alerts {
  position: fixed;
  bottom: 0;
  left: 10px;
  right: 10px;
  max-height: 50vh;
  overflow-y: hidden;
  z-index: 1100;
}

.app-container {
  position: relative;
  min-height: 100%;
  padding-bottom: 80px;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
}
</style>

<style>
.clickable {
  cursor: pointer;
  user-select: none;
}

::-webkit-input-placeholder {
  color: #ccc !important;
}
::-moz-placeholder {
  color: #ccc !important;
}
:-ms-input-placeholder {
  color: #ccc !important;
}
:-moz-placeholder {
  color: #ccc !important;
}

.text-muted {
  color: #bbb !important;
}

.custom-checkbox .custom-control-label {
  cursor: pointer; /* bootstrap-vue checkbox */
}

.form-group > label,
legend,
.custom-form-label {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue